import { ChangeDetectionStrategy, AfterViewInit, Component, ElementRef, inject, OnInit } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { StateTypes } from '@ortho-next/nextray-core';
import { CanvasService, PrinterService, UserService } from '../../services';
import { PrintPageOneComponent } from './page-one';
import { PageThreeComponent } from './page-three';
import { PrintPageTwoComponent } from './page-two';


/**
* Main component of OR Plan PDF print.
*/
@Component({
	selector: 'app-or-plan-print',
	templateUrl: './prt-or-plan.component.html',
	imports: [
		PageThreeComponent,
		PrintPageTwoComponent,
		PrintPageOneComponent
	],
	changeDetection: ChangeDetectionStrategy.Eager
})
export class PrintOrPlanComponent implements OnInit, AfterViewInit {

	private readonly userSrv = inject(UserService);
	private readonly element = inject(ElementRef);
	private readonly prtSrv = inject(PrinterService);
	private readonly canvasSrv = inject(CanvasService);

	/**
	 * Today's date time.
	 */
	today = new Date();
	/**
	 * Flag indicating whether the page is available for printing.
	 */
	hasPageOne?: boolean;
	/**
	 * Flag indicating whether the page is available for printing.
	 */
	hasPageTwo?: boolean;
	/**
	 * Flag indicating whether the page is available for printing.
	 */
	hasPageThree?: boolean;

	private _stateType?: StateTypes;
	private readonly isPltDemo = toSignal(this.userSrv.isPlatformDemo(), { initialValue: false });
	private readonly isJPSDemo = toSignal(this.userSrv.isJPSDemoProduct(), { initialValue: false });

	/**
	 * Watermark Demo.
	 */
	get isDemo(): boolean {
		return this._stateType === StateTypes.templating ? this.isJPSDemo() : this.isPltDemo();
	}


	ngOnInit(): void {
		this._stateType = this.canvasSrv.stateType;
		this.hasPageOne = !!this._stateType && this._stateType >= StateTypes.deformityAnalysis;
		this.hasPageTwo = this.canvasSrv.isEocCut;
		this.hasPageThree = this._stateType === StateTypes.templating;
	}

	ngAfterViewInit(): void {
		const elem = this.element.nativeElement;
		this.prtSrv.onORPlanDataReady(elem);
	}

}
